var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4167 2.50008H6.5C5.09987 2.50008 4.3998 2.50008 3.86502 2.77257C3.39462 3.01225 3.01217 3.3947 2.77248 3.86511C2.5 4.39988 2.5 5.09995 2.5 6.50008V13.5001C2.5 14.9002 2.5 15.6003 2.77248 16.1351C3.01217 16.6055 3.39462 16.9879 3.86502 17.2276C4.3998 17.5001 5.09987 17.5001 6.5 17.5001H14.1667C14.9416 17.5001 15.3291 17.5001 15.647 17.4149C16.5098 17.1837 17.1836 16.5099 17.4148 15.6471C17.5 15.3292 17.5 14.9417 17.5 14.1667M15.8333 6.66675V1.66675M13.3333 4.16675H18.3333M8.75 7.08341C8.75 8.00389 8.00381 8.75008 7.08333 8.75008C6.16286 8.75008 5.41667 8.00389 5.41667 7.08341C5.41667 6.16294 6.16286 5.41675 7.08333 5.41675C8.00381 5.41675 8.75 6.16294 8.75 7.08341ZM12.4917 9.93187L5.44262 16.3401C5.04614 16.7006 4.84789 16.8808 4.83036 17.0369C4.81516 17.1722 4.86704 17.3064 4.96932 17.3964C5.08732 17.5001 5.35523 17.5001 5.89107 17.5001H13.7133C14.9126 17.5001 15.5123 17.5001 15.9833 17.2986C16.5745 17.0457 17.0456 16.5746 17.2985 15.9833C17.5 15.5124 17.5 14.9127 17.5 13.7134C17.5 13.3099 17.5 13.1081 17.4559 12.9202C17.4005 12.6841 17.2941 12.4629 17.1444 12.2721C17.0252 12.1202 16.8677 11.9942 16.5526 11.7421L14.2215 9.8773C13.9062 9.62501 13.7485 9.49886 13.5748 9.45434C13.4218 9.4151 13.2607 9.42018 13.1104 9.46899C12.94 9.52437 12.7905 9.6602 12.4917 9.93187Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlus);
export default __webpack_public_path__ + "static/media/image-plus.e14e8cab5157d6a6653e7b53e1a02707.svg";
export { ForwardRef as ReactComponent };